(function() {

    'use strict';



    var mimeTypes = [
        'video/mp4',
        'video/x-mp4',
        'video/flv',
        'video/x-flv',
        'rtmp/flv',
        'rtmp/x-flv',
        'rtmp/mp4',
        'rtmp/x-mp4'
        //'application/x-mpegurl'
    ];

    var rtmpMimeTypes = [
        'rtmp/flv',
        'rtmp/x-flv',
        'rtmp/mp4',
        'rtmp/x-mp4'
    ];



    var SWF = SAPO.Utility.SWF;
    var arrIndexOf = SAPO.Utility.arrIndexOf;



    function FlashVideoBuilder(item, parentEl) {
        var objectEl;
        var id = ~~(Math.random() * 100000);

        var readySymbol = '_ready' + id;
        //var eventSymbol = '_event' + id;
        //var errorSymbol = '_error' + id;

        window[readySymbol] = function(/*id*/) {
            // console.log('READY');
            objectEl.style.zIndex = '';

            setTimeout(function() {
                objectEl.vjs_setProperty('volume', 0.2); // TODO temp
            }, 250);
        };

        /*window[eventSymbol] = function(id, evName, val) {
            console.log('EVENT', evName, val);
        };

        window[errorSymbol] = function(id, errName) {
            console.error('ERROR', errName);
        };*/



        var flashVars = { // https://github.com/videojs/video-js-swf/blob/master/src/VideoJS.as
             autoplay:                'true'
            ,readyFunction:           readySymbol
            // ,eventProxyFunction:      eventSymbol
            // ,errorEventProxyFunction: errorSymbol
            // ,debug
            // ,mode
            // ,preload
            // ,src
            // ,rtmpConnection
            // ,rtmpStream
            // ,poster
        };

        if (arrIndexOf(rtmpMimeTypes, item.type) !== -1) {
            var lastSlash = item.src.lastIndexOf('/');
            flashVars.rtmpConnection = item.src.substring(0, lastSlash);
            flashVars.rtmpStream     = item.src.substring(lastSlash + 1);
        }
        else {
            flashVars.src = item.src;
        }

        objectEl = SWF.embed({
            swf:       '/SAPO/Project/Video/assets/flash/videojs.swf', // SWF file to load TODO FIX LOCATION
            dims:      item.dims,                   // dimensions in pixels
            //id:        'vpaid',                  // id and name for object element (if ommitted, random one will be generated)
            container: parentEl,            // container element
            params: { // params
                 allowfullscreen:   true     // if trueish, allowfullscreen param is set to true
                ,allowscriptaccess: 'always' // allowscriptaccess param
                ,wmode:             'opaque' // wmode param: opaque | transparent | window
                 //bgcolor:           '#FF0000',     // bgcolor param
                 //quality:           'high'         // quality param
            },
            flashvars: flashVars, // flashVars
            insteadOf: false // if true, repaces container, otherwise appends container
        });

        objectEl.style.zIndex = 10000;
    }



    function FlashVideoHdlr(item) { // isLinear must be true here...
        if (
            item.nodeName !== 'MediaFile' ||
            arrIndexOf(mimeTypes, item.type) === -1
        ) { return; }

        return {
            mimeType:    item.type,
            description: 'linear flash-powered video',
            item:        item,
            builder:     FlashVideoBuilder
        };
    }



    SAPO.Project.Video.VAST.handlers.FlashVideo = FlashVideoHdlr;

})();
